import ValidationInterface from '@/plans/common/validation-interface';
import { bizPlusCategories, proPlusCategories, USCallingCategories } from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires(cart) {
    const headsetCategories = cart.planMap.filter((p) => p.type === "zoom_device$headset").map(p => p.category);
    return [this.current(headsetCategories).require([...USCallingCategories, ...proPlusCategories, ...bizPlusCategories])];
  }

  async conflicts() {
    return [];
  }
}
